import React, { useState } from "react";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import "./Services.css";
import ServicesData from "./ServiceData";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const Services = () => {
  // Split services into chunks of 5
  const chunkSize = 5;
  const serviceChunks = [];
  
  for (let i = 0; i < ServicesData.length; i += chunkSize) {
    serviceChunks.push(ServicesData.slice(i, i + chunkSize));
  }

  // State to track current slide
  const [currentSlide, setCurrentSlide] = useState(0);

  // Handle navigation
  const goToNextSlide = () => {
    if (currentSlide < serviceChunks.length - 1) {
      setCurrentSlide(currentSlide + 1);
      // Scroll to top on mobile/tablet
      if (window.innerWidth <= 1024) {
        document.getElementById('service-cards-top')?.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  const goToPrevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
      // Scroll to top on mobile/tablet
      if (window.innerWidth <= 1024) {
        document.getElementById('service-cards-top')?.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  return (
    <section
      id="service-section"
      className="service-section common-padding"
      data-aos="fade-up"
      data-aos-duration="2000"
    >
      <div className="container">
        {/* Header */}
        <div className="row service-header">
          <div className="col-lg-6 col-sm-12">
            <SectionTitle
              title="Services That Elevate Your Experience"
              subTitle="Services"
            />

          </div>
          <div className="col-lg-6 col-sm-12">
               <p className="service-title-text">
            Discover our comprehensive dental care, tailored for every age and need.
             From routine cleanings and preventive checkups to advanced cosmetic, restorative, and pediatric treatments, our clinic is dedicated
              to helping you achieve optimal oral health and confidence. Explore our services below to see how we can support your healthiest,
               brightest smile—with compassionate expertise, the latest techniques, and state-of-the-art technology in every procedure.
          </p>
                       
          </div>
        </div>

        {/* Scroll anchor for mobile */}
        <div id="service-cards-top"></div>

        {/* Services Grid */}
        <div className="carousel-container">
          <div className="services-grid">
            {serviceChunks[currentSlide].map((service, index) => (
              <Link
                 to={`/services#${service.slug}`}
                key={service.slug}
                className="service-card"
                data-aos="fade-up"
                data-aos-delay={`${index * 100}`}
              >
                <div className="service-image">
                  <img src={service.imageUrl} alt={service.title} />
                </div>
                <h4 className="service-home-title">{service.title}</h4>
              </Link>
            ))}
          </div>

          {/* Navigation Controls */}
          {serviceChunks.length > 1 && (
            <div className="carousel-controls">
              <button
                className={`carousel-btn ${currentSlide === 0 ? "disabled" : ""}`}
                onClick={goToPrevSlide}
                disabled={currentSlide === 0}
                aria-label="Previous services"
              >
                <ChevronLeft size={22} />
              </button>

              <div className="carousel-indicators">
                {serviceChunks.map((_, index) => (
                  <span
                    key={`indicator-${index}`}
                    className={`indicator ${currentSlide === index ? "active" : ""}`}
                    onClick={() => setCurrentSlide(index)}
                    role="button"
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>

              <button
                className={`carousel-btn ${
                  currentSlide === serviceChunks.length - 1 ? "disabled" : ""
                }`}
                onClick={goToNextSlide}
                disabled={currentSlide === serviceChunks.length - 1}
                aria-label="Next services"
              >
                <ChevronRight size={22} />
              </button>

            </div>
          )}
           
        </div>
        {/* VIEW ALL SERVICES BUTTON */}
          <div className="view-all-services-wrapper">
            <Link to="/services" className="view-all-services-btn">
              View All Services
            </Link>
          </div>
      </div>
    </section>
  );
};

export default Services;
